import { useEffect } from 'react';

import { useStoreDispatch } from 'store/hooks/storeHooks';
import { openResetPasswordModal, setPasswordResetToken } from 'store/slice/accountModalSlice';

interface IResetPasswordProps {
  passwordResetToken: string | null;
}

const ResetPassword = ({ passwordResetToken }: IResetPasswordProps) => {
  const storeDispatch = useStoreDispatch();

  useEffect(() => {
    storeDispatch(openResetPasswordModal());

    storeDispatch(setPasswordResetToken(passwordResetToken));
  }, [passwordResetToken]);

  return <></>;
};

export const getServerSideProps = ({ query }) => {
  const { token } = query;

  return {
    props: {
      passwordResetToken: typeof token === 'string' ? token : null,
    },
  };
};

export default ResetPassword;
